module.exports = __webpack_public_path__ + "img/header-engagementRingsLabGrownDiamonds.1d9a009.jpg";